import { REGISTER_BASE_EXCLUDE_PROPERTIES, RegisterBaseModel } from '@rift/models/restapi/RegisterBase.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { isNullOrUndefined } from '@shared/utility/General.Utility';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { IRegisterBaseModel } from '@rift/models/restapi/IRegisterBase.Model';

export interface IRegisterOccupancyMasterModel extends IRegisterBaseModel {
    inRegisters: Array<number>;
    outRegisters: Array<number>;
    externalRegisters: Array<number>;
    resetTimeout: number;
    waitIndex?: number;
    waitRegisterEnabled: boolean;
}

/**
 * Represents a
 *
 * @export
 * @class RegisterOccupancyMasterModel
 * @extends {RegisterBaseModel}
 * @implements {IRegisterOccupancyMasterModel}
 * @implements {IRestModel}
 */
export class RegisterOccupancyMasterModel extends RegisterBaseModel implements IRegisterOccupancyMasterModel, IRestModel {

    public inRegisters: Array<number> = null;
    public outRegisters: Array<number> = null;
    public externalRegisters: Array<number> = null;
    public resetTimeout: number = null;
    public waitIndex?: number = null;
    public waitRegisterEnabled: boolean = null;

    public constructor() {
        super();

        this.registerProperty('inRegisters');
        this.registerProperty('outRegisters');
        this.registerProperty('externalRegisters');
        this.registerProperty('resetTimeout');
        this.registerProperty('waitIndex');
        this.registerProperty('waitRegisterEnabled');
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-RegisterOccupancyMasterModel', ['registerType', ...REGISTER_BASE_EXCLUDE_PROPERTIES]);
        super.loadFromRestApiModel(restModel);

        this.setPropertyOriginalValue('inRegisters', this.inRegisters);
        this.setPropertyOriginalValue('outRegisters', this.outRegisters);
        this.setPropertyOriginalValue('externalRegisters', this.externalRegisters);
        this.setPropertyOriginalValue('resetTimeout', this.resetTimeout);
        this.setPropertyOriginalValue('waitIndex', this.waitIndex);
        this.setPropertyOriginalValue('waitRegisterEnabled', this.waitRegisterEnabled);

        this.setIndexes();
    }

    public toRestApiModel(): any {
        return {
            ...super.toRestApiModel(),
            InRegisters: this.inRegisters,
            OutRegisters: this.outRegisters,
            ExternalRegisters: this.externalRegisters,
        };
    }

    public setIndexes(): void {
        if (isNullOrUndefined(this.inRegisters)) {
            this.inRegisters = [];
        }
        if (isNullOrUndefined(this.outRegisters)) {
            this.outRegisters = [];
        }
        if (isNullOrUndefined(this.externalRegisters)) {
            this.externalRegisters = [];
        }

        super.setIndexesBase([], [...this.inRegisters, ...this.outRegisters, ...this.externalRegisters], []);
    }

}
